export const locale = {
    lang: 'en',
    data: {
        'TOOLBAR': {
            'TOOLTIP_ADD': 'Click to add/remove shortcut',
            'SEARCH_PLACEHOLDER': 'Search for an app or a page'
        }
    }
};



// WEBPACK FOOTER //
// ./src/@fuse/components/shortcuts/i18n/en.ts